exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-outline-secondary[data-v-25065eb4]{min-width:75px}.active[data-v-25065eb4]{font-weight:700;background-color:#ecebeb}.pagination-div[data-v-25065eb4]{padding:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25065eb4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/store/components/DataListComponent.vue
// module id = rToW
// module chunks = 102